import { mapMutations } from 'vuex'
export default {
    data() {
        return {
            searchPageShow: false, // 是否展示搜索组件
        };
    },
    watch: {
        searchPageShow(val) {
            this.TAB_BAR_SHOW(!val)
        }
    },
    methods: {
        ...mapMutations([
            'TAB_BAR_SHOW'
        ]),
        // 进入搜索页
        entoSearchPage() {
            this.searchPageShow = true
            this.$nextTick(() => {
                this.$refs.searchPageRef.$refs.searchInputTmpl.$refs.searchInput.focus()
            })
        },
        goSearchResult(searchText) {
            this.searchPageShow = false
            this.$router.push({ name: 'searchResult', query: { search: searchText } })
        },
        searchResult(inputVal) {
            this.$router.push({ name: 'searchResult', query: { search: inputVal } })
        },
        hideInput() {
            this.searchPageShow = false
        },
    },
    beforeDestroy() {
        this.searchPageShow = false
    },
}